const meetupSchedule = [
  {
    title: "08:30 - 09:00",
    info: "Reception",
  },
  {
    title: "09:10 - 09:45",
    info: "Andrew Cargill, CEO @ Zapiet - Zero to Zapiet: A Developer's Path to Retail Innovation",
  },
  {
    title: "09:25 - 09:40",
    info: "Emili @ Zapiet - Power of Brand Collaboration: Emotional Sales Intelligence",
  },
  {
    title: "09:50 - 10:25",
    info: "Catalin Ciochina - Co-Founder, CEO @ xConnector - xConnector's Journey: From Client Conversations to Code",
  },
  {
    title: "10:35 - 10:50",
    info: "Ruben Bristian - Co-Founder, CEO @ Krown Themes - Let's Talk Performance!",
  },
  {
    title: "10:55 - 11:10",
    info: "TBD",
  },
  {
    title: "11:15 - 11:45",
    info: "Networking Break",
  },
  {
    title: "11:50 - 12:20",
    info: "Maurice Junghans, Shopify - Future of Commerce",
  },
  {
    title: "12:25 - 12:55",
    info: "Bogdan Dogaru, Co-Founder & CTO @ Vevol Media - Shopify, Teams, and the Future of E-commerce",
  },
  {
    title: "13:00 - 14:00",
    info: "1h Lunch Break",
  },
  {
    title: "14:00 - 15:00",
    info: "Panel Discussion: 5 Interesting Super Guests",
  },
  {
    title: "15:00 - 15:35",
    info: "Stefan Chiriacescu @ eCommerce Today - Eat My Dust! Leave Your Competition Behind with Email Automation & AI Used Strategically",
  },
  {
    title: "15:40 - 16:15",
    info: "Alex @ Epsifund - Pricing Strategy for Shopify Apps",
  },
  {
    title: "17:30",
    info: "Afterparty",
  },
];

export default meetupSchedule;
